var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Titles extends Component {
    constructor() {
        super('Titles', false);
        this.imageList = {};
        this.indexes = {};
        this.lastPosition = { x: 0, y: 0 };
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (window.matchMedia('(pointer:fine)').matches) {
                this.loadImageLists();
                $('.modules-titles h2').on('mouseenter', (event) => {
                    this.mouseEnterHandler(event);
                }).on('mousemove', (event, element) => {
                    this.mouseMoveHandler(event, element);
                });
            }
            this.success();
        });
    }
    loadImageLists() {
        $('.modules-titles h2').each((element) => __awaiter(this, void 0, void 0, function* () {
            const projectId = parseInt(element.data('projectId'));
            if (isNaN(projectId))
                return;
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_project_images',
                    'project_id': projectId,
                },
                dataType: 'json'
            });
            this.imageList[projectId] = response;
            this.indexes[projectId] = 0;
        }));
    }
    dropImage(element) {
        const projectId = parseInt(element.data('projectId'));
        if (isNaN(projectId))
            return;
        const imageURL = this.imageList[projectId][this.indexes[projectId] % this.imageList[projectId].length];
        this.indexes[projectId]++;
        const image = $.parseHTML(`<div class="dropped-image position-absolute"><img src="${imageURL}" class="d-block w-100"></div>`);
        image.css({
            top: this.lastPosition.y,
            left: this.lastPosition.x,
        });
        element.append(image);
        setTimeout(() => {
            image.addClass('dropped-image--fade-out');
        }, 500);
        setTimeout(() => {
            image.remove();
        }, 1000);
    }
    updateLastPosition(event) {
        this.lastPosition = { x: event.layerX, y: event.layerY };
    }
    distance(event) {
        return Math.sqrt(Math.pow(event.layerX - this.lastPosition.x, 2) + Math.pow(event.layerY - this.lastPosition.y, 2));
    }
    mouseEnterHandler(event) {
        this.updateLastPosition(event);
    }
    mouseMoveHandler(event, element) {
        if (!this.lastPosition)
            this.updateLastPosition(event);
        if (this.distance(event) > 100) {
            this.updateLastPosition(event);
            this.dropImage(element);
        }
    }
}
